import { useToast } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"
import { useEffect, useTransition } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { setCurrentPageId, setToaster, setTranslator } from "~/redux/context"
import { actions } from "~/redux/process"
import { application } from "~/redux/state/application"
import { usePage } from "./usePage"
import { usePageSession } from "./usePageSession"

export const useBootstrapPage = (pageId: EntityId) => {
  const { t } = useTranslation()
  const toast = useToast()
  setToaster(toast)
  setCurrentPageId(pageId)
  setTranslator(t)

  const dispatch = useDispatch()

  const { page } = usePage(pageId)
  const { pageSession } = usePageSession(page.id)

  useEffect(() => {
    //debugJson will be reset on every page load
    window.debugJson = {}
  }, [pageId])

  useEffect(() => {
    window.appVersion = process.env.GATSBY_APP_VERSION ?? "0.0.0"
    dispatch(application.actions.setCurrentPageId(pageId))
    if (!pageSession.isReady) {
      dispatch(actions.bootstrapPage({ id: pageId, toast }))
    }
  }, [dispatch, pageId, pageSession.isReady, toast])
}
